import { Button } from "@/components/ui/button";
import { useSessionStore } from "@/store/session";
import { cn } from "@/lib/utils";
import { ShieldCheck, LogOut } from "lucide-react";
import { useCallback } from "react";

interface AppHeaderProps {
    className?: string;
    summaryText: string;
}

export const AppHeader = ({ className, summaryText }: AppHeaderProps) => {
    const user = useSessionStore((state) => state.user);
    const logout = useSessionStore((state) => state.logout);

    const handleLogout = useCallback(async () => {
        await logout().catch(() => null);
    }, [logout]);

    return (
        <header
            className={cn(
                "sticky top-0 z-30 flex h-20 items-center border-b border-border/70 bg-card/95 px-6 shadow-sm backdrop-blur-md",
                className,
            )}
        >
            <div className="flex w-full items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                    <span className="grid h-11 w-11 place-items-center rounded-xl border border-primary/30 bg-primary/10 text-primary">
                        <ShieldCheck className="h-6 w-6" />
                    </span>
                    <div>
                        <h1 className="text-xl font-semibold leading-tight text-primary">Audit Logs</h1>
                        <p className="text-sm text-muted-foreground">{summaryText}</p>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <div className="text-right">
                        <p className="text-sm font-medium text-primary">
                            {user?.email ?? "Authenticated user"}
                        </p>
                        <p className="text-xs text-muted-foreground">
                            {user?.role?.name ?? "Audit analyst"}
                        </p>
                    </div>
                    <Button variant="outline" size="sm" onClick={handleLogout} className="gap-2">
                        <LogOut className="h-4 w-4" />
                        Log out
                    </Button>
                </div>
            </div>
        </header>
    );
};

